import React from 'react'

// import the pages components
import IndexPage from '../account/home'
import Cards from '../account/cards'
import CreateNewCard from '../account/createnewcard'
import CardDetails from '../account/carddetails'
import Dealsandoffers from '../account/dealsandoffers'
import AccountSettings from '../account/settings'
import Logout from './signout'

function UniversalPageSwitchLayout(props) {
    const page = props.page

    if (page === "index") {
        return (
            <IndexPage />
        )

    } else if (page === "cards") {
        return (
            <Cards />
        )

    } else if (page === "addnewcard") {
        return (
            <CreateNewCard />
        )

    } else if (page === "carddetails") {
        return (
            <CardDetails />
        )

    } else if (page === "dealsandoffers") {
        return (
            <Dealsandoffers />
        )

    } else if (page === "accountsettings") {
        return (
            <AccountSettings />
        )

    } else if (page === "logout") {
        return (
            <Logout />
        )

    } else {
        return (
            <h5>Page not found</h5>
        )
    }
}

export default UniversalPageSwitchLayout